export default __webpack_public_path__ + "static/media/HSL_OpenMaaS_API_privacy_statement_20190730.a2ed71ba.pdf";